import React from 'react';
import {
  StapleTableBody,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { FileAvailabilityRole } from 'types/policyService';
import DownloadFileTableRow from '../DownloadFileTableRow';
import { StapleTableHeadingStyled, StapleTableStyled } from './styles';

export interface DownloadFile {
  id: string;
  name: string;
  availability?: FileAvailabilityRole;
}
interface DownloadFilesTableProps extends ICustomizableElement {
  loading: boolean;
  filesList: DownloadFile[];
  onDownload: (id: string, name: string) => void;
}

const DownloadFilesTable: React.FC<DownloadFilesTableProps> = ({ loading, filesList, className, onDownload }) => {
  return (
    <div className={className}>
      <StapleTableStyled loading={loading} totalElements={filesList.length}>
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading width="30rem">File Name</StapleTableHeading>
            <StapleTableHeadingStyled width="8rem" />
            <StapleTableHeadingStyled width="8rem" />
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBody>
          {filesList.map((file, index) => (
            <DownloadFileTableRow
              name={file.name}
              key={file.id}
              indexNumber={index + 1}
              availability={file.availability}
              onDownload={() => onDownload(file.id, file.name)}
            />
          ))}
        </StapleTableBody>
      </StapleTableStyled>
    </div>
  );
};

export default DownloadFilesTable;
